import { ReportRequestInterface, ReportRequestModuleInterface } from '@src/domain/types';
import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import { ServiceRequestPost, ServiceRequestPostRequest } from 'cmp-client-api';

const transformToApiModel = (model: ReportRequestModuleInterface): ServiceRequestPostRequest =>
  ({
    module: model.selectedModule,
    title: model.title,
    requestType: 'dashboard',
    description: model.description,
    deploysServiceModule: model.deploysServiceModule,
    inputs: model.inputs,
    deploymentContext: model.deploymentContext,
  } as ServiceRequestPostRequest);

const transformFromApiModel = (response: ServiceRequestPost): ReportRequestInterface => ({
  ...response.data,
  supportSystem: response.data.serviceNow,
});

export const ReportRequestMapper: MapperInterface<
  ReportRequestInterface,
  ServiceRequestPostRequest
> = {
  transformFromApiModel,
  transformToApiModel,
} as never;
